import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <a
        href="https://github.com/idiotmitts/weather-react"
        target="_blank"
        class="source-link"
      >
        Open-source code{" "}
      </a>
      by Emma Semple
    </div>
  );
}
